import _ from "lodash";
import client from "lib/apolloClient/client";
import { fetchThirdPartyDriveAttachmentRevisionDataQuery } from "./GoogleDocsPlaybackViewerQueries";
import axios from "axios";
import { Sentry } from "services/sentry";

/**
 * Fetch third party drive attachment revision data
 * @param {string} attachmentId - The attachment ID
 * @returns {Promise<Object>} - The revision data response
 */
export const fetchThirdPartyDriveAttachmentRevisionData = async attachmentId => {
  try {
    const response = await client.query({
      query: fetchThirdPartyDriveAttachmentRevisionDataQuery,
      variables: {
        id: attachmentId,
      },
      fetchPolicy: "network-only",
    });

    const responseDataObj = _.get(
      response,
      "data.node.thirdPartyDriveAttachmentRevisionData",
      {}
    );

    const fallbackCloudUrl = _.get(responseDataObj, "warning", "");
    //when response data exceeds 5.5 mb, cloud url is returned from BE
    if (fallbackCloudUrl && _.includes(fallbackCloudUrl, "cloud.toddleapp")) {
      // axios cloudUrl
      const cloudResponse = await axios.get(fallbackCloudUrl);
      const cloudData = _.get(cloudResponse, "data", {});
      let revisionData = {};
      if (cloudData?.isSuccess) {
        revisionData = _.get(cloudData, "response", {});
      }

      return {
        ...responseDataObj,
        response: revisionData,
        warning: "",
      };
    }

    return responseDataObj;
  } catch (error) {
    const errorMsg = _.get(error, "message", "");
    if (
      !_.get(error, "networkError") &&
      !_.includes(
        [
          "GOOGLE_ACCOUNT_NOT_LINKED",
          "USER_LACKS_REVISIONS_PERMISSION",
          "UNSUPPORTED_FILE_TYPE",
        ],
        errorMsg
      ) &&
      !_.includes(_.toLower(errorMsg), "file not found")
    ) {
      Sentry.captureMessage(`GOOGLE_PLAYBACK_ERROR`, {
        level: "info",
        extra: {
          reason: _.get(error, "message", ""),
          attachmentId,
        },
      });
    }

    return {
      isSuccess: false,
      warning: errorMsg,
    };
  }
};
